import Data from 'assets/img/icons/data.svg';
import SMS from 'assets/img/icons/sms.svg';
import Voice from 'assets/img/icons/voice.svg';
import DataRoaming from 'assets/img/icons/roaming-data.svg';
import VoiceRoaming from 'assets/img/icons/roaming-voice.svg';
import SmsRoaming from 'assets/img/icons/roaming-sms.svg';

const Icons = (type: string, group: string): string =>
	({
		data: {
			general: Data,
			special: Data,
			roaming: DataRoaming,
		},
		sms: {
			general: SMS,
			special: SMS,
			roaming: SmsRoaming,
		},
		voice: {
			general: Voice,
			special: Voice,
			roaming: VoiceRoaming,
			international: Voice,
		},
	}[type][group] || Data);

export default Icons;
